/**
 * Contatori ROL / Ex festività: valori orari centesimali a 3 decimali in visualizzazione,
 * indipendenti dal formato durate dell'azienda. Arrotondamento matematico (half-up) senza
 * errori di rappresentazione binaria; i calcoli usano sempre il valore interno (6 decimali).
 */
export const COUNTER_DISPLAY_DECIMALS = 3;
export const COUNTER_STORAGE_DECIMALS = 6;

export function roundHalfUp(value, decimals = COUNTER_DISPLAY_DECIMALS) {
  const v = Number(value);
  if (!Number.isFinite(v)) return 0;
  const sign = v < 0 ? -1 : 1;
  return sign * Number(`${Math.round(Number(`${Math.abs(v)}e${decimals}`))}e-${decimals}`);
}

export const formatCounterHours = (value) =>
  roundHalfUp(value).toLocaleString("it-IT", { minimumFractionDigits: COUNTER_DISPLAY_DECIMALS, maximumFractionDigits: COUNTER_DISPLAY_DECIMALS });

/** "6,456777" | "6.456777" → 6.456777 (precisione interna); null se non valido. */
export function parseCounterHours(text) {
  const s = String(text ?? "").trim().replace(/\s/g, "").replace(",", ".");
  if (s === "") return 0;
  if (!/^\d*\.?\d*$/.test(s) || s === ".") return null;
  return roundHalfUp(Number(s), COUNTER_STORAGE_DECIMALS);
}
